
import { Component } from "react";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import Loader from "../../../../../utils/Loader";
import { ToastContainer, toast } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { getStallDesignDetails_action, insertUpdateStallDesign_action } from '../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/stallDesign_action/stallDesign_action'
import $ from 'jquery'
import { toastError, toastSuccess } from "../../../../../utils/constants";
import Resizer from "react-image-file-resizer";
import { BASE_URL } from "../../../../../utils/constants";
import Modal from "react-modal";
// import Modal from "react-bootstrap/Modal";
import moment from "moment";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";
import {
  insertUpdateExhibitorContractorBadgeApplication_action,
  getExhibitorContractorBadgeApplicationDetails_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/exhibitorContractorBadgeApllication_action/exhibitorContractorBadgeApllication_action";

class StallDesign extends Component {

  //Initialize constructor
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      ExhibitorName: "",
      StallName: "",
      HallName: "",
      OpenSides: "",
      StallArea: "",
      StallTypeName: "",
      filePath_1: "",
      filePath_2: "",
      filePath_3: "",
      filePath_4: "",
      filePath_5: "",
      filePath_6: "",
      filePath_7: "",

      fileName_1: "",
      fileName_2: "",
      fileName_3: "",
      fileName_4: "",
      fileName_5: "",
      fileName_6: "",
      fileName_7: "",

      fileType_1: "",
      fileType_2: "",
      fileType_3: "",
      fileType_4: "",
      fileType_5: "",
      fileType_6: "",
      fileType_7: "",

      Remark: "",
      DeadlineDate: "",
      currentDate: moment().format("DD-MM-YYYY"),

      StallDesignFormID: null,
      FloorPlanDocument: null,
      ThreeDViewDocument: null,
      FrontViewDocument: null,
      SupportingDocument: null,
      DimentionalView: null,
      FireSafteyCertificate: null,

      displayfile_1: "",
      displayfile_2: "",
      displayfile_3: "",
      displayfile_4: "",
      displayfile_5: "",
      displayfile_6: "",
      displayfile_7: "",
      isOpen: false,

      modalImagePath: "",
      modalImageName: "",

      is_View: false,
      StatusID: "",
      isOpen2: false,
      isCollapse: false,
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      CompanyName: '',
      PersonName: '',
      Email: '',
      Mobile: '',
      SetUpDayPasses: '',
      DismantleDayPasses: '',

      CompanyNameErr: '',
      PersonNameErr: '',
      EmailErr: '',
      MobileErr: '',
      SetUpDayPassesErr: '',
      DismantleDayPassesErr: '',
      Is_Agree: false,
      Is_AgreeErr: '',
      ExhContractorBadgeID: '',

      isUpdateFile_1: false,
      isUpdateFile_2: false,
      isUpdateFile_3: false,
      isUpdateFile_4: false,
      isUpdateFile_5: false,
      isUpdateFile_6: false,
      isUpdateFile_7: false,

      TechnicalLayout: ''
    };

    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.handleSubmit()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    const VendorDetails = this.props.location.state != null ? this.props.location.state.VendorDetails
      : null;
    this.setState({
      DeadlineDate: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.Deadline != "" ?
        moment(this.props.location.state.Deadline).format('DD-MM-YYYY') : '',
      is_View: this.props.location.state != null && this.props.location.state.is_View ?
        this.props.location.state.is_View : sessionStorage.getItem("RoleIDSS") != 1,
      StatusID: this.props.location.state != null && this.props.location.state.StatusID ?
        this.props.location.state.StatusID : '',
      CompanyName: VendorDetails?.CompanyName || "-",
      PersonName: VendorDetails?.PersonName || "-",
      Email: VendorDetails?.EmailID || "-",
      Mobile: VendorDetails?.MobileNo || "-",
    })
    console.log("this.props----------------->", this.props)
    this.loadscript()
    this.getStallDesignetails()
    this.getExhibitorContractorBadgeApplicationDetails()
  }

  getExhibitorContractorBadgeApplicationDetails() {
    const { } = this.state;
    this.setState({ isLoading: true });
    this.props
      .getExhibitorContractorBadgeApplicationDetails_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          if (data.data[0]["ExhContractorBadgeID"]) {
            this.setState({
              CompanyName: data.data[0]["CompanyName"],
              PersonName: data.data[0]["PersonName"],
              Email: data.data[0]["Email"],
              Mobile: data.data[0]["Mobile"],
              SetUpDayPasses: data.data[0]["SetUpDayPasses"],
              DismantleDayPasses: data.data[0]["DismantleDayPasses"],
              ExhContractorBadgeID: data.data[0]["ExhContractorBadgeID"],
              Remark: data.data[0]["Remark"],
              Is_Agree: data.data[0]["IsAgree"],
            });
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  getStallDesignetails() {
    const { Remark, Is_Agree, isQuantity, Is_Required } = this.state
    this.setState({ isLoading: true })
    this.props
      .getStallDesignDetails_action()
      .then((data) => {
        if (data.error != 1) {

          this.setState({
            isLoading: false,
            ExhibitorName: data.data[0]['ExhibitorName'] != null ? data.data[0]['ExhibitorName'] : '-',
            StallName: data.data[0]['StallName'] != null ? data.data[0]['StallName'] : '-',
            HallName: data.data[0]['HallName'] != null ? data.data[0]['HallName'] : '-',
            OpenSides: data.data[0]['OpenSides'] != null ? data.data[0]['OpenSides'] : '-',
            StallArea: data.data[0]['StallArea'] != null ? data.data[0]['StallArea'] : '-',
            StallTypeName: data.data[0]['StallTypeName'] != null ? data.data[0]['StallTypeName'] : '-',
            FloorPlanDocument: data.data[0]['FloorPlanDocument'],
            ThreeDViewDocument: data.data[0]['ThreeDViewDocument'],
            FrontViewDocument: data.data[0]['FrontViewDocument'],
            SupportingDocument: data.data[0]['SupportingDocument'],
            DimentionalView: data.data[0]['DimentionalView'],
            TechnicalLayout: data.data[0]['TechnicalLayout'],
            FireSafteyCertificate: data.data[0]['FireSafteyCertificate'],
            StallDesignFormID: data.data[0]['StallDesignFormID'],
            Remark: data.data[0]['Remark']
          })

          const url = BASE_URL.split('/api')

          if (data.data[0]['FloorPlanDocument'] != null) {
            const file = data.data[0]['FloorPlanDocument'].split(`${data.data[0]['ExhRegistrationID']}/`)
            this.setState({ fileName_1: file[1], displayfile_1: url[0] + data.data[0]['FloorPlanDocument'] })
          }
          if (data.data[0]['ThreeDViewDocument'] != null) {
            const file = data.data[0]['ThreeDViewDocument'].split(`${data.data[0]['ExhRegistrationID']}/`)
            this.setState({ fileName_2: file[1], displayfile_2: url[0] + data.data[0]['ThreeDViewDocument'] })
          }
          if (data.data[0]['FrontViewDocument'] != null) {
            const file = data.data[0]['FrontViewDocument'].split(`${data.data[0]['ExhRegistrationID']}/`)
            this.setState({ fileName_3: file[1], displayfile_3: url[0] + data.data[0]['FrontViewDocument'] })
          }
          if (data.data[0]['SupportingDocument'] != null) {
            const file = data.data[0]['SupportingDocument'].split(`${data.data[0]['ExhRegistrationID']}/`)
            this.setState({ fileName_4: file[1], displayfile_4: url[0] + data.data[0]['SupportingDocument'] })
          }
          if (data.data[0]['DimentionalView'] != null) {
            const file = data.data[0]['DimentionalView'].split(`${data.data[0]['ExhRegistrationID']}/`)
            this.setState({ fileName_5: file[1], displayfile_5: url[0] + data.data[0]['DimentionalView'] })
          }
          if (data.data[0]['FireSafteyCertificate'] != null) {
            const file = data.data[0]['FireSafteyCertificate'].split(`${data.data[0]['ExhRegistrationID']}/`)
            this.setState({ fileName_6: file[1], displayfile_6: url[0] + data.data[0]['FireSafteyCertificate'] })
          }

          if (data.data[0]['TechnicalLayout'] != null) {
            const file = data.data[0]['TechnicalLayout'].split(`${data.data[0]['ExhRegistrationID']}/`)
            this.setState({ fileName_7: file[1], displayfile_7: url[0] + data.data[0]['TechnicalLayout'] })
          }
        }
        else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  handleSubmit() {
    const { Remark,
      filePath_1,
      filePath_2,
      filePath_3,
      filePath_4,
      filePath_5,
      filePath_6,
      filePath_7,

      fileName_1,
      fileName_2,
      fileName_3,
      fileName_4,
      fileName_5,
      fileName_6,
      fileName_7,

      fileType_1,
      fileType_2,
      fileType_3,
      fileType_4,
      fileType_5,
      fileType_6,
      fileType_7,

      StallDesignFormID,
      FloorPlanDocument,
      ThreeDViewDocument,
      FrontViewDocument,
      SupportingDocument,
      DimentionalView,
      FireSafteyCertificate,
      SetUpDayPasses,
      DismantleDayPasses,
      Is_Agree,
      isUpdateFile_1,
      isUpdateFile_2,
      isUpdateFile_3,
      isUpdateFile_4,
      isUpdateFile_5,
      isUpdateFile_6,
      isUpdateFile_7,
      TechnicalLayout
    } = this.state
    this.inputValidate()
    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    if (
      SetUpDayPasses != "" &&
      SetUpDayPasses != null &&
      DismantleDayPasses != "" &&
      DismantleDayPasses != null &&
      Is_Agree
    ) {
      if (fileName_1 != '' && fileName_2 != '' && fileName_3 != '' && fileName_4 != '' && fileName_7 != '') {
        this.setState({ isLoading: true })
        this.props
          .insertUpdateStallDesign_action(
            StallDesignFormID,
            FloorPlanDocument,
            ThreeDViewDocument,
            FrontViewDocument,
            SupportingDocument,
            DimentionalView,
            FireSafteyCertificate,
            TechnicalLayout,
            Remark,
            filePath_1,
            filePath_2,
            filePath_3,
            filePath_4,
            filePath_5,
            filePath_6,
            filePath_7,
            fileName_1,
            fileName_2,
            fileName_3,
            fileName_4,
            fileName_5,
            fileName_6,
            fileName_7,
            fileType_1,
            fileType_2,
            fileType_3,
            fileType_4,
            fileType_5,
            fileType_6,
            fileType_7,
            ManualFormsID, ServiceID, VendorDetails,
            isUpdateFile_1,
            isUpdateFile_2,
            isUpdateFile_3,
            isUpdateFile_4,
            isUpdateFile_5,
            isUpdateFile_6,
            isUpdateFile_7,
          )
          .then((data) => {
            if (data.error != 1) {
              this.saveContractorBadge()
            }
            else {
              this.setState({ isLoading: false })
              toastError(data.msg)
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        toastError("Please Choose Mandatory File's")
        this.setState({ isLoading: false })
      }
    } else {
      toastError("Please enter mandatory fields!");
      this.setState({ isLoading: false });
    }
  }

  onFilePick = async (e, file, typeName) => {
    e.preventDefault();

    if (!file || file.length === 0) return;

    const selectedFile = file[0];

    // ✅ File size validation
    if (selectedFile.size >= 3 * 1024 * 1024) {
      toastError('File size more than 3MB is not allowed.');
      return;
    }

    const fileName = selectedFile.name.toLowerCase();

    // ✅ File type validation
    const allowedTypes = ['.jpeg', '.jpg', '.png'];
    const isValid = allowedTypes.some(ext => fileName.endsWith(ext));

    if (!isValid) {
      toast.error('Only .jpg, .jpeg, .png files are allowed', {
        position: "top-center",
        theme: 'colored',
        autoClose: 3000,
        hideProgressBar: true,
      });
      return;
    }

    // ✅ Convert file
    const image = await this.convertToBase64(selectedFile);

    // ✅ Extract index (file_1 → 1)
    const index = typeName.split('_')[1];

    // ✅ Extract file type safely
    const finalFileTypeName = selectedFile.type.includes('/')
      ? selectedFile.type.split('/')[1]
      : '';

    // ✅ SINGLE setState (important)
    this.setState({
      [`filePath_${index}`]: image,
      [`fileName_${index}`]: selectedFile.name,
      [`displayfile_${index}`]: image,
      [`fileType_${index}`]: finalFileTypeName,
      [`isUpdateFile_${index}`]: true
    });
  };

  convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {

      const reader = new FileReader()

      reader.readAsDataURL(file)

      reader.onload = () => resolve(reader.result)

      reader.onerror = error => reject(error)
    })
  }

  removeFile(e, fileType) {
    e.preventDefault()
    if (fileType == 'file_1') {
      this.setState({ FloorPlanDocument: null, fileName_1: '', filePath_1: '', fileType_1: '', displayfile_1: '', isUpdateFile_1: true })
    } else if (fileType == 'file_2') {
      this.setState({ ThreeDViewDocument: null, fileName_2: '', filePath_2: '', fileType_2: '', displayfile_2: '', isUpdateFile_2: true })
    } else if (fileType == 'file_3') {
      this.setState({ FrontViewDocument: null, fileName_3: '', filePath_3: '', fileType_3: '', displayfile_3: '', isUpdateFile_3: true })
    } else if (fileType == 'file_4') {
      this.setState({ SupportingDocument: null, fileName_4: '', filePath_4: '', fileType_4: '', displayfile_4: '', isUpdateFile_4: true })
    } else if (fileType == 'file_5') {
      this.setState({ DimentionalView: null, fileName_5: '', filePath_5: '', fileType_5: '', displayfile_5: '', isUpdateFile_5: true })
    } else if (fileType == 'file_6') {
      this.setState({ FireSafteyCertificate: null, fileName_6: '', filePath_6: '', fileType_6: '', displayfile_6: '', isUpdateFile_6: true })
    } else if (fileType == 'file_7') {
      this.setState({ TechnicalLayout: null, fileName_7: '', filePath_7: '', fileType_7: '', displayfile_7: '', isUpdateFile_7: true })
    }
  }

  handleCancel() {
    window.history.back();
  }

  showImage(typeName, name) {
    const { displayfile_1,
      displayfile_2,
      displayfile_3,
      displayfile_4,
      displayfile_5,
      displayfile_6, displayfile_7 } = this.state
    this.setState({
      isOpen: true,
    })
    if (typeName == 'file_1') {
      this.setState({ modalImagePath: displayfile_1, modalImageName: name })
    } else if (typeName == 'file_2') {
      this.setState({ modalImagePath: displayfile_2, modalImageName: name })
    } else if (typeName == 'file_3') {
      this.setState({ modalImagePath: displayfile_3, modalImageName: name })
    } else if (typeName == 'file_4') {
      this.setState({ modalImagePath: displayfile_4, modalImageName: name })
    } else if (typeName == 'file_5') {
      this.setState({ modalImagePath: displayfile_5, modalImageName: name })
    } else if (typeName == 'file_6') {
      this.setState({ modalImagePath: displayfile_6, modalImageName: name })
    } else if (typeName == 'file_7') {
      this.setState({ modalImagePath: displayfile_7, modalImageName: name })
    }
  }

  inputValidate() {
    const {
      Is_Agree,
      SetUpDayPasses,
      DismantleDayPasses,
    } = this.state;

    if (SetUpDayPasses == null || SetUpDayPasses == "") {
      this.setState({
        SetUpDayPassesErr: "Please Enter No. of Passes/Bands Required for setup days",
      });
    }
    if (DismantleDayPasses == null || DismantleDayPasses == "") {
      this.setState({
        DismantleDayPassesErr: "Please Enter No. of Passes/Bands Required for dismantle days",
      });
    }
    if (Is_Agree == 0 || Is_Agree == false) {
      this.setState({
        Is_AgreeErr: "kindly agree to Guidelines and Exhibition rules of INDIA ITME 2026",
      });
    }
  }

  saveContractorBadge() {
    const {
      CompanyName,
      PersonName,
      Address,
      Email,
      Mobile,
      LandlineNo,
      SetUpDayPasses,
      DismantleDayPasses,
      Remark,
      Is_Agree,
      ExhContractorBadgeID,
    } = this.state;
    this.inputValidate();
    this.setState({ isLoading: true });
    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    this.props
      .insertUpdateExhibitorContractorBadgeApplication_action(
        CompanyName,
        PersonName,
        Address,
        Email,
        Mobile,
        LandlineNo,
        SetUpDayPasses,
        DismantleDayPasses,
        Remark,
        Is_Agree,
        ExhContractorBadgeID,
        ManualFormsID,
        ServiceID,
        VendorDetails
      )
      .then((data) => {
        if (data.error != 1) {
          toastSuccess(this.state.StatusID == 0 ? 'Stall Design Form Submitted Successfully' : 'Stall Design Form Updated Successfully')
          setTimeout(() => {
            this.props.navigate('/manualForms')
          }, 2000);
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  render() {
    const { isLoading, ExhibitorName, StallName, HallName, OpenSides, StallArea, StallTypeName, Remark, currentDate, DeadlineDate,
      fileName_1,
      fileName_2,
      fileName_3,
      fileName_4,
      fileName_5,
      fileName_6,
      fileName_7,

      displayfile_1,
      displayfile_2,
      displayfile_3,
      displayfile_4,
      displayfile_5,
      displayfile_6,
      displayfile_7,
      isOpen,
      modalImagePath,
      modalImageName,
      is_View,
      StatusID,
      isOpen2,
      isCollapse,
      isHideSection, isOpenConfirmationModal,

      CompanyName,
      PersonName,
      Email,
      Mobile,
      SetUpDayPasses,
      DismantleDayPasses,

      CompanyNameErr,
      PersonNameErr,
      EmailErr,
      MobileErr,
      SetUpDayPassesErr,
      DismantleDayPassesErr,
      Is_Agree,
      Is_AgreeErr,
    } = this.state
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY") &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));
    return (
      <>
        {/* {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null} */}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
              JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
              <ExhibitorHeader />
            ) : (
              <HeaderWithLogo />
            )}
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
              JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
              <ExhibitorDrawer />
            ) : (
              <AdminDrawer />
            )}
          </>
        )}
        <div className={!isHideSection ? "with-dr-container exb-top-space" : "exb-top-space"}>
          <div className="">
            {!isHideSection && (
              <div className="row">
                {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
                  JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
                  <ExhibitorTopMenu />
                ) : null}
              </div>
            )}
            <div className="row mx-2 mt-3">
              <div className="col-xl-12 p-1">
                <div className="card rounded p-0 shadow-none border">
                  <div className="card-header">
                    <h3 className="card-title" style={{ textAlign: "left" }}>
                      {" "}
                      Booth Design Approval <br />
                      {/* Note:{" "}
                      <span className="fw-semibold">
                        (Refer floor plan ceiling Height-3.80m (under blue line). stall height 3
                        meter only)
                      </span>
                      */}
                    </h3>
                  </div>
                  {/* {!isHideSection && (
                    <div className="card-body p-3 text-left">
                      <div className="row ">
                        <h6 className="mt-2">
                          1) The cost/rates and terms &amp; conditions of utilizing the
                          individual services from the given service provider is solely
                          discretion of exhibitors.
                        </h6>
                        <h6 className="mt-2">
                          2) India ITME Society is only information facilitator for the service
                          provider &amp; in no event shall India ITME Society be liable for any
                          direct, indirect, punitive, incidental, special consequential issues,
                          whatsoever arising out of taking services with the above given service
                          provider.
                        </h6>
                      </div>
                      <ol type="1)" style={{ textAlign: "left" }}>
                        <li>
                          The exhibitor is responsible for safety at the stand and for ensuring
                          that industrial safety and accident prevention regulations are
                          complied with. The exhibitor is liable for any damage that results
                          from the construction or running of his stand or the exhibits
                          displayed in it. Conditions inside and outside the halls as well as on
                          the open-air site are similar to those on a building site throughout
                          the construction and dismantling periods. The personnel working in
                          this environment must be made aware of the dangers that exist.
                        </li>
                        <li>
                          To achieve uniformity in display and appearance of the entire
                          exhibition and to ensure proper presentation of all exhibits,
                          Exhibitors are advised to strictly follow the guidelines for stand
                          construction, decoration and display specified by the Organisers.
                        </li>
                        <li>
                          There would be general lighting within the hall. Temporary electrical
                          connection would be provided to carry on the construction work only
                          from 0800 hrs to 1900 hrs, which will be disconnected at 1900 hrs till
                          0800 hrs next morning
                        </li>
                        <li>
                          Aisles in the halls must be kept clear at all times, even during the
                          construction and dismantling period since they are required as rescue
                          and escape routes. Construction material, empty packaging and exhibits
                          are not allowed to be stored in the aisles.
                        </li>
                        <li>
                          Digging or grouting or cutting of floor is not permitted in any Hall.
                        </li>
                        <li>
                          Organisers will allot only bare space with proper marking of the
                          borders on the floor for the area booked by the exhibitors.
                          Construction of partition walls is the responsibility of the bare
                          space stall holder. For example, a single side open bare space stall
                          holder will have the responsibility of constructing partition walls on
                          3 sides. While finishing is to be carried out only on one side, facing
                          your stand, if you can co-ordinate with the adjoining stand owner and
                          finish from both sides, thereby reducing the manpower and cost for
                          both the exhibitors.
                        </li>
                        <li>
                          Exhibitors are required to submit stall layout plan, elevation and 3D
                          artist’s impression, online for it’s approval positively before
                          00.00.000.
                        </li>
                        <li>
                          An exhibitor whose design has been approved by the IITME architect,
                          can commence fabrication after taking official possession of the stall
                          area. No exhibitor shall be allowed to start work on their stand
                          without prior approval of the design. The decision of the ITME
                          architect as regards to the approval of the design shall be final and
                          binding upon exhibitors and the work must be carried out as per the
                          approved design only.
                        </li>
                        <li>
                          Exhibitors are advised not to use any vacant space around and behind
                          their stands for storage or otherwise. This could be hazardous and
                          could restrict the movement of service personnel. Organisers reserve
                          the right to remove such material at the risk & cost of the Exhibitor.
                        </li>
                        <li>
                          Workers having night badges issued by the organisers will be allowed
                          to stay inside the halls at night and that too only within their stall
                          area from 2100 hrs to 0800 hrs next day. Any worker, Contractor,
                          Exhibitors’ representative, material supplier, wanting to enter the
                          exhibition halls must have an official badge issued by the Organisers.
                        </li>
                        <li>
                          Double Storey maybe permitted to be constructed inside the stands
                          having an area of above 54 Sqm. subject to payment of additional space
                          rent and on the following conditions :-
                        </li>
                        <ol type="a">
                          <li>
                            Area of Double Storey shall not exceed 25% of the stand area subject
                            to approval of the show architect.
                          </li>
                          <li>
                            Maximum clear height below the Double Storey shall not exceed 2.2
                            mtrs. Overall height of the stand including double storey shall not
                            exceed 5.0 Mts
                          </li>
                          <li>
                            The railing on the sides of the Double Storey shall be of
                            transparent material in the portion extending beyond 2.5 mtrs.
                            Height from the ground level.
                          </li>
                          <li>
                            Any stall which is not along the natural wall; Double Storey
                            covering through the solid wall is not allowed and only open Double
                            Storey with railing of maximum 1.5 Mtr. height is permissible.
                          </li>
                          <li>
                            A strip of at least 0.10 Mtr. must be mounted along the edge of the
                            Double Storey beneath the railing to prevent falling of objects.
                          </li>
                          <li>
                            Walls adjoining neighbouring stands on the Double Storey must be
                            sufficiently stable so as to prevent accidental falling of persons
                            or objects.
                          </li>
                          <li>
                            Exhibitor to get a structural engineer to duly certify the stability
                            of the structure of the Double Storey and the Organisers shall not
                            be held responsible for any mishap due to the sub-standard design /
                            workmanship / material used while the construction of the Double
                            Storey . Any sub-standard construction leading to collapse of Double
                            Storey / accidents will be penalised and blacklisted for future
                            editions
                          </li>
                          <li>
                            The construction of Double Storey shall be permitted only if, in the
                            opinion of the Fair Architect, it is not obstructing the display /
                            visibility of any adjoining stand(s).
                          </li>
                          <li>
                            No branding is allowed on and above the Double Storey s or 5.0 Mts
                            whichever is higher.
                          </li>
                          <li>
                            Only railing of maximum height of 1.5 Mtr without any branding is
                            allowed in the front and open sides of the stand.
                          </li>
                          <li>
                            Meeting rooms on Double Storey , if required, should be constructed
                            in the center leaving 1.0 Mtr from the periphery in case the Double
                            Storey is to be placed along a partition that is common with another
                            stand.
                          </li>
                          <li>
                            Walls of meeting rooms on Double Storey should be of transparent
                            material above 1.2 Mts height.
                          </li>
                          <li>
                            The approval and use of Double Storey area shall be subject to
                            payment @ 50% of the total stall charges payable for the area used
                            for Double Storey .
                          </li>
                          <li>
                            The Double Storey s can be used only as a visitor hospitality lounge
                            and meeting areas. Exhibits / graphic display/ Video walls will not
                            be permitted on the Double Storey .
                          </li>
                          <li>
                            Approval of Mezzanine shall be granted only if the design is
                            accompanied with the Structural Stability certificate from a
                            certified Structural engineer
                          </li>
                        </ol>
                        <h6>11.2 Double Storey Design Guideline</h6>
                        <ol type="a">
                          <li>
                            Offices / cabins with closed walls & ceilings are strictly
                            prohibited on the Double Storey . The Double Storey must be an open
                            area only with safety railings on open sides.
                          </li>
                        </ol>
                        <h6>11.3 Escape routes</h6>
                        <ol type="a">
                          <li>
                            Nearest escape route / exit should have been provided no further
                            than 10 mtrs from any location within the stand. Exhibitors are to
                            ensure that such routes / exits are not blocked or obstructed in any
                            way.
                          </li>
                          <li>
                            Double Storey s with areas{">"}50 sq.mtrs. must have two stairways –
                            one for entry and one for exit. Such staircases must be placed
                            separately and not next to each other for better escape route
                          </li>
                        </ol>
                        <h6>11.4 Stairways</h6>
                        <ol type="a">
                          <li>Staircase risers in all steps must be completely closed.</li>
                          <li>
                            The riser of each step should not exceed 0.20 mtrs and the tread
                            depth must be at least 0.25 mtrs in the middle of the steps.
                          </li>
                          <li>
                            Handrails are required on both the sides of the stairway. They must
                            provide a safe grip and must be free of gaps even on landings.
                          </li>
                          <li>
                            Handrail clearance to an adjacent structure must be at least 0.10
                            mtrs.
                          </li>
                          <li>
                            The width of stairway should be at least 1.25 mtrs and should not
                            exceed 1.5 mtrs.
                          </li>
                        </ol>
                        <h6>11.5 Stairways</h6>
                        <ol type="a">
                          <li>
                            Safety railings must be at least 1.5 mtrs high and consist of a top,
                            middle and bottom rail.
                          </li>
                        </ol>
                        <h6>11.6 Fire prevention & Stall height</h6>
                        <ol type="1">
                          <li>
                            Any load bearing elements of the Double Storey must be flame
                            retardant.
                          </li>
                          <li>
                            The Double Storey should be equipped with at least one fire
                            extinguishers per 20 Sq. Mts of Double Storey .
                          </li>
                          <li>
                            Double Storey Structural Stability Certificate with technical
                            specifications approved by Structural Engineer has to be submitted
                            to the IITME 2022 Secretariat for approval at the time of submission
                            of design.
                          </li>
                          <li>
                            The completion certificate from the structural engineer has to be
                            provided before the use of such a mezzanine structure.
                          </li>
                          <li>
                            Exhibitors should leave minimum 30% of the stall area free for
                            movement of visitors.
                          </li>
                          <li>
                            The panels adjacent to other stand areas and the ceilings of the
                            stand areas that are visible from above must be properly finished in
                            neutral colour without any branding towards the adjacent stands.
                          </li>
                          <li>
                            All stands with an accessible platform higher than 50mm must have an
                            access ramp and the slope of such ramp(s) must be uniform and not
                            more than 8%. This ramp/ slope must fall within the stand area and
                            must not protrude into the aisle.
                          </li>
                          <li>
                            Organisers suggest co-operation between neighboring exhibitors for
                            construction and finishing of common partitions.
                          </li>
                          <li>
                            Sides, which are open to the aisles, should not be blocked by panels
                            for more than 30% of the length of such side. Any structure,
                            publicity material, photographs, charts, should not have height
                            exceeding 4.0 meters. However, products higher than 4.0 Mts on
                            display and placed directly on the floor without artificially
                            raising the height can be more than 4.0 meters as per availability
                            of height within the premises. Height of panels and common panels
                            between stalls should not be more than 4.0 meters and should have
                            smooth surface on both sides. However, the back wall of the stall
                            against natural wall of the hall can go up to a height of 5.0
                            meters, wherever available.{" "}
                            <span className="fw-semibold">
                              (Refer floor plan ceiling Height-3.80m (under blue line). stall
                              height 3 meter only)
                            </span>
                            .
                          </li>
                          <li>
                            Pillars in the stalls may be covered with paneling up to height of
                            5.0 meters without grouting on the wall, floor or causing damage of
                            any nature to the structure of the exhibition hall. A clear access
                            with proper signage should be provided on such paneling, in case the
                            pillar has electrical main supply point/ distribution boards for
                            access to electric supply/ Fire extinguishers/ Fire Control Panels.
                          </li>
                          <li>
                            No suspensions are to be made from the trusses of the Exhibition
                            Hall. Exhibitors will not be permitted to fasten machines or any
                            part of display may be attached, nailed, screwed or drilled on to
                            the floor, columns, wall or any other part of the hall. If this
                            instruction is ignored, the Exhibitor/Contractor concerned will be
                            penalized for the damage thus caused.
                          </li>
                          <li>
                            A back wall must be provided, except in the case of an island stall.
                            The Organiser reserves the right to change, modify, lower or shorten
                            any back wall or sidewall, if such a wall, in the opinion of the
                            Organiser/ Fair Architect, may obstruct the reasonable view or
                            exposure of other Exhibitors’ stalls at the cost and risk of the
                            exhibitor.
                          </li>
                          <li>
                            Exhibitors applying for shell scheme construction would be provided
                            partitions on all covered sides and a fascia indicating company name
                            and stand number.
                          </li>
                          <li>
                            Use of bright and/or coloured decorative lights, neon signs of any
                            size, shape or colour (including those depicting exhibitor’s name or
                            logo) or any other similar electrical decorative materials is
                            strictly forbidden.
                          </li>
                          <li>
                            Use of any type of loudspeakers or musical instrument in the stalls
                            is forbidden. Use of video tapes for display and demonstration will
                            be permitted.
                          </li>
                          <li>
                            Use of all types of banners, hanging decorations made by paper,
                            cloth or any other inflammable material etc. is strictly forbidden.
                            Use of flowers in vases and potted plants is welcome.
                          </li>
                          <li>
                            Carpeting/ Floor covering of the stands is compulsory for all
                            Exhibitors. Use of suitable commercial material for floor covering
                            inside the stands is permitted. Gluing/ pasting of carpet on the
                            floor may be done only by using easily removable bi-adhesive tape
                            that leaves no marks on the floor.
                          </li>
                          <li>
                            Enclosures for office, conference or pantry can be set up in the
                            stalls provided the height and area covered by such enclosures is
                            not more than 4.0 meters and 30% of the stall area respectively.
                            Such enclosures should be located along the building wall of the
                            exhibition hall, if any, or at the rear of the stall. Enclosures
                            should be at least 2 meters away from the aisles/ open sides.
                            Enclosures have to conform to the open side regulation as per point
                            number 16. In case length of such Enclosures is more than the
                            prescribed length, it shall be at least 2 meters away from aisles.
                          </li>
                          <li>
                            For stands with 3/4 open sides, there shall be no partitions for
                            more than 30% of the length of any open side and the inside
                            partitions should also be such that they do not obstruct the view or
                            aesthetics of the adjoining stand/s. In case they are found to be
                            obstructive, such partitions shall have to be provided with clear
                            glass / acrylic above 1.2 meters height.
                          </li>
                          <li>
                            No part of any structure or exhibit, including overhangs/
                            cantilevers, would be allowed to extend beyond the boundaries of the
                            stall allocated. This includes, symbols, logos, lighting, floral
                            decorations, furnishings etc.
                          </li>
                          <li>
                            Logos and single branding signages can be displayed by exhibitors up
                            to a height of 4.0 meters for stands up to 54 Sq. Mts, up to a
                            height of 5.0 meters for stands up to 108 Sq. Mts provided they are
                            away from adjacent stalls by a minimum distance of 1.5 meters and up
                            to a height of 6.0 meters for stands above 108 Sq. Mts provided they
                            are away from adjacent stalls by a minimum distance of 2 meters and
                            subject to height available in the Hall.
                          </li>
                          <li>
                            All the halls are air-conditioned. However, the participants who
                            desire to install air-conditioning facility in their cabins would
                            need to raise a request for the same. Permission for installation of
                            Air conditioners is subject to approval received from venue owners
                            as they normally don't allow such installations.
                          </li>
                          <li>
                            Exhibitors shall keep and maintain the interiors including all
                            fittings, fixtures etc. belonging to BCEC in good order and
                            condition and will leave the same in as good a condition as they
                            were on the date of possession of the stall.
                          </li>
                          <li>
                            Kindly note that all Exhibitors, Media Partners, Associates and
                            Agents are allowed to do promotion, distribution or marketing within
                            their respective booth. No temporary or unauthorized staff will be
                            allowed to distribute pamphlets or do any marketing outside their
                            booth or use public areas to do so. All staff allowed inside
                            exhibition premises will have to get permission from organizers to
                            be inside venue and should carry identity badges
                          </li>
                          <li>
                            We request your co-operation in this regard and help us to conduct
                            the event in an organized and planned way, and safe manner making it
                            convenient for both the exhibitors/visitors and the organizers.
                          </li>
                          <li>
                            Use of all types of publicity materials such as posters, banners,
                            hanging decorations made of any material is not allowed outside the
                            stall area of the exhibitors. Suspending of display items from the
                            Hall ceiling or any other structure falling within the stands is
                            also not permitted.
                          </li>
                          <li>
                            Posters, banners, hangings and advertisement boards will be put up
                            by the Organisers and will be available as sponsorship opportunities
                            for the exhibitors.
                          </li>
                          <li>
                            Use of potted plants is allowed only inside the stall area of the
                            exhibitor.
                          </li>
                          <li>
                            Exhibitors are requested to note that it is the responsibility of
                            their appointed stall-fitting contractors to clean the stalls upon
                            completion of construction, before handing over to the Exhibitor.
                            Thereafter, the official cleaning contractor will clean the aisles.
                            Kindly also ensure that they carry out the prevalent Sanitization
                            Protocol as governed by the venue and Organiser guidelines.
                          </li>
                          <li>
                            The guidelines for bare space stalls (as stated above) are also
                            applicable to the contractors/ exhibitors carrying out interior
                            decoration for the stalls under shell scheme.
                          </li>
                          <li>
                            Exhibitors are advised to take insurance policy covering their
                            machinery/exhibit, transit and loading and unloading of machines,
                            their exhibition personnel, vendors and third parties (visitors).
                          </li>
                        </ol>
                      </ol>

                    </div>
                  )} */}
                  {!isHideSection && (
                    // <div className="card-body p-3 text-left">
                    <div className="text-left mt-2">
                      {/* <h6>General Guidelines applicable to Bare Space Construction</h6> */}

                      <ol>
                        <li>
                          <strong>Height Restrictions:</strong>
                          <ul style={{ listStyleType: "disc" }}>
                            <li>
                              All partitions and other display features must be limited to a maximum height of <span className="fw-semibold">4.0 meters</span>, including any raised platform. Partitions against the
                              natural wall of existing structures may be constructed up to <span className="fw-semibold">5.0 meters</span> in height.
                            </li>

                            {/* <li>
                              <span className="fw-semibold">Shell Stalls:</span> Maximum permitted height is
                              <span className="fw-semibold"> 2.5 meters</span>.
                            </li> */}

                            <li>
                              Product displays exceeding <span className="fw-semibold"> 4.0 meters</span> in height are permitted,
                              provided they are free-standing, placed directly on the floor, and not positioned
                              on any elevated surface.
                            </li>

                            <li>
                              For stalls designated for mezzanine construction, the total stall height,
                              including the mezzanine floor, must not exceed
                              <span className="fw-semibold"> 5.0 meters</span>.
                            </li>

                            <li className="fw-semibold">
                              Where there is a height difference between partitions of two adjacent stalls,
                              and the partition height remains within the maximum permissible limit, the exposed
                              rear surface of the higher partition (not exceeding 4.0 meters) must be finished with a neutral paint finish.
                            </li>
                          </ul>
                        </li>
                      </ol>
                      <ol start="2">
                        <li>
                          <strong>Stall Identification</strong>
                          <ul style={{ listStyleType: "disc" }}>
                            <li>Display the stall number (minimum size: 2 x 2 feet) in a visible location.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>Open Space Requirement</strong>
                          <ul style={{ listStyleType: "disc" }}>
                            <li>Leave 70% of open sides along the aisle free of construction to improve visitor access and visibility.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>Partition Walls Construction</strong>
                          <ul style={{ listStyleType: "disc" }}>
                            <li>Organizers provide bare space with marked borders. Partition walls must be constructed by the exhibitor.</li>
                            <li>For partitions that are obstructive, clear glass/acrylic must be used above 1.2 meters.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>Open-Sided Stalls</strong>
                          <ul style={{ listStyleType: "disc" }}>
                            <li>Open sides should not be blocked with solid partitions for more than 30% of the length of the open side.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>Back Walls</strong>
                          <ul style={{ listStyleType: "disc" }}>
                            <li>A back wall is mandatory except for island stalls.</li>
                            <li>The organizers reserve the right to ask exhibitors to modify any wall that exceeds the permitted height and blocks the view of neighbouring stalls.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>Enclosures</strong>
                          <ul style={{ listStyleType: "disc" }}>
                            <li>Offices, pantries, or conference enclosures:</li>
                            <li>Height: Maximum 4.0 meters.</li>
                            <li>Area: Maximum 30% of stall space.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>Pillar Coverage</strong>
                          <ul style={{ listStyleType: "disc" }}>
                            <li>Cover pillars up to <span className="fw-semibold"> 4.0 meters </span>using panels, ensuring no damage.</li>
                            <li>Provide a door for access to electrical supply or fire services, if applicable.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>Logos &amp; Branding</strong>
                          <ul style={{ listStyleType: "disc" }}>
                            <li>
                              Branding above <span className="fw-semibold">4 Meter height</span> and up to<span className="fw-semibold"> 5.0 Meter height</span> is allowed provided it is away from the adjacent stalls by at least <span className="fw-semibold">1 Meter</span>, and no branding should overlook the neighbouring stalls and should face towards the Aisles only.
                            </li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>Neighbouring Walls</strong>
                          <ul style={{ listStyleType: "disc" }}>
                            <li>
                              Bare space exhibitors cannot display name boards on the back or side walls towards neighbouring stalls but can place them on any side facing the aisles.
                            </li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>Accessibility</strong>
                          <ul style={{ listStyleType: "disc" }}>
                            <li>
                              Raised platform may be constructed not exceeding 150mm in height. There should be at least one ramp of <span className="fw-semibold">1M x 1M</span> provided in the raised platform for ease of access for Especially abled visitors. There should be no sharp edges of such raised platforms, and the corners need to be protected with Soft Corner Guards.
                            </li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong><span class="highlight">Additional Guidelines for Mezzanine Floor Construction</span></strong>

                          <p className="mb-0">The area of the mezzanine floor should not exceed 25% of the ground area booked.</p>
                          <p className="mb-0">Mezzanine floor construction is allowed subject to the following conditions:</p>

                          <ol type="a">
                            <li>Mezzanine floor is permitted for bare stalls above <span className="fw-semibold">72 sq. meters</span> only and up to a maximum of <span className="fw-semibold">25%</span> of the total area booked. The mezzanine structure should be placed at least 1 meter away from adjacent stalls.</li>

                            <li>Minimum clear height below the mezzanine floor shall be <span className="fw-semibold">2.1 meters</span>.</li>

                            <li>Mezzanine floors with areas greater than <span className="fw-semibold">100 sq. meters</span> must have two stairways—one for entry and one for exit. Such staircases must be placed separately and not next to each other to provide a better escape route.</li>

                            <li>There should be a safety skirting of at least <span className="fw-semibold">100 mm</span> height all around the mezzanine floor and a railing on top of it with a maximum height of <span className="fw-semibold">1500 mm</span>.</li>

                            <li>The width of the staircase should be a minimum of <span className="fw-semibold">1000 mm</span>, riser should not exceed <span className="fw-semibold">175 mm</span>, and tread should be a minimum of <span className="fw-semibold">275 mm</span>.</li>

                            <li>Mezzanine areas are to be used for discussion/meeting purposes only. No exhibits, graphics, or video walls are allowed on the mezzanine floor.</li>

                            <li>All structures should be designed for a nut-and-bolt assembly system. Welding is not allowed at the venue.</li>

                            <li>All mezzanine structure designs must be accompanied by a Structural Stability Certificate duly stamped and signed by a Registered Structural Engineer, clearly mentioning their registration number.</li>

                            <li>Construction of mezzanine floors is not allowed in Halls No. 1, 3, 5, and 7.</li>
                          </ol>
                        </li>

                        <li className="mt-2">
                          <strong><span class="highlight">Worker Rules</span></strong>
                          <ul style={{ listStyleType: "disc" }}>
                            <li>Workers must be 18 years or older and carry organizer-issued badges for hall access during construction and breakdown.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong><span class="highlight">Other Guidelines</span></strong>
                          <ul style={{ listStyleType: "disc" }}>
                            <li>Exhibitors/fabricators should use prefabricated structures to the maximum extent possible to enable faster installation and allow more time for machinery movement and installation.</li>

                            <li>Artificial grass, grass carpets, creepers, plants, fur carpets, dry grass/leaves, and any other materials/items that pose a fire hazard are prohibited, irrespective of approval for stand design.</li>

                            <li>All wiring used in fabrication shall be copper. The use of aluminum wiring is strictly prohibited.</li>

                            <li>All workers working on pedestals or at heights must wear proper safety gear, including safety shoes, helmets, and safety belts.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong><span class="highlight">Important Points for Site Construction</span></strong>
                          <ul style={{ listStyleType: "disc" }}>
                            <li>Use a carpet matching the stand area size to protect the venue flooring.</li>

                            <li>Maintain approved drawings, permissions, and ensure a responsible person is present onsite at all times.</li>

                            <li>All packing materials must be collected and placed at a designated corner for housekeeping. Littering will result in a penalty of ₹500 per incident.</li>

                            <li className="fw-semibold">Contractor passes/wristbands are issued free of charge. Contractors must preserve their setup-day passes/wristbands for use during dismantling days. No fresh passes/wristbands will be issued for dismantling days.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong><span class="highlight">Electrical</span></strong>
                          <ul style={{ listStyleType: "disc" }}>
                            <li>From the power supply point, only 3 wires for single-phase and 5 wires for three-phase connections are permissible for internal distribution.</li>

                            <li>It is mandatory for exhibitors to provide an internal distribution board inside the stall.</li>

                            <li>Exhibitors must submit their layout plan indicating the power supply point.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong><span class="highlight">Security Deposit</span></strong><br />
                          <span className="fw-semibold">This need to be deposited by the booth fabricator while completing the contractor registration formalities i.e. booth possession. The security deposit amount should be paid in DEMAND DRAFT ONLY and drawn in favour of ‘India ITME Society’. The same to be handed over to the officials of India ITME Society present on-site and to be collected from onsite post clearing the booth material materials.</span><br />

                          <i>(Please write the details with pencil on behind of demand draft like contracting Company Name, Contact Person, Mobile No.., along exhibiting company name, Mobile No Contact Person details)</i>
                        </li>
                        <div style={{ width: "800px", marginTop: "10px" }}>
                          <table style={{ borderCollapse: "collapse" }}>
                            <thead>
                              <tr>
                                <th style={{ border: "1px solid #000", padding: "8px", textAlign: "left", backgroundColor: "#d9c2b0", fontWeight: "bold" }}>
                                  Stall Size
                                </th>
                                <th style={{ border: "1px solid #000", padding: "8px", textAlign: "center", backgroundColor: "#d9c2b0", fontWeight: "bold" }}>
                                  Refundable Security Amount (Demand Draft Only)
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td style={{ border: "1px solid #000", padding: "8px" }}>Up to 50 m2</td>
                                <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center", fontWeight: "bold" }}>
                                  INR 15,000/-
                                </td>
                              </tr>
                              <tr>
                                <td style={{ border: "1px solid #000", padding: "8px" }}>50 m2 – 100 m2</td>
                                <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center", fontWeight: "bold" }}>
                                  INR 30,000/-
                                </td>
                              </tr>
                              <tr>
                                <td style={{ border: "1px solid #000", padding: "8px" }}>Above 100 m2</td>
                                <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center", fontWeight: "bold" }}>
                                  INR 40,000/-
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <p className="text-center text-danger">Demand Draft Only accepted. No cheque or cash.</p>
                        </div>
                        <p className="fw-semibold mb-0">Deadline to Complete the work for {sessionStorage.getItem("ExhibitionName")}.</p>
                        <p className="mb-0">The deadline to complete the fabrication/touch up work of Raw / Bare Space (stand above 27 Sqm only) is only till <span className="fw-semibold mb-0">12:00 P.M of 02.12.2026 </span> post which it will attract penalty and uncompleted construction work will be halted. </p>

                        <p className="fw-semibold mb-0">It is Advised to bring pre-fabricated material as the venue being a pre-installed carpeted venue.</p>
                      </ol>

                    </div>
                  )}

                  <div class="card-header border-top" style={{ marginBottom: isCollapse ? '' : "15px" }}>
                    <h3 class="card-title" style={{ fontsize: "15px", marginRight: "15px" }}>
                      Electrical Guidelines
                    </h3>
                    <span
                      style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }}
                      onClick={() => this.setState({ isCollapse: !isCollapse })}
                    >
                      click here to {isCollapse ? "hide" : "read"} Guidelines
                    </span>
                  </div>
                  {isCollapse && (
                    <div class="card-body p-1 m-2">
                      <div className="text-left">
                        <p>Exhibitors under Bare Space category are required to apply for power supply and pay electricity connection/consumption charges on the basis of required connected load for machinery, including lighting and air-conditioning. Exhibitors should inform their power requirements along with the payment towards power charges before <span className="fw-semibold">{this.props.location?.state?.ActualDeadline
                          ? moment(
                            this.props.location.state.ActualDeadline
                          ).format("DD/MM/YYYY")
                          : "-"}.
                        </span></p>
                        <ol>
                          <li>Exhibitors should note that 1kw supply/outlet is compulsory in every single stall as a facility for lighting. Every exhibitor must submit their layout plan with indication of point of power supply.</li>

                          <li>The stall contractors undertaking lighting work shall possess valid electrical wireman license.</li>

                          <li>The load ≤ 3 kW shall be fed through single phase electrical supply at 230V AC ± 6 % and load &gt; 3 kW shall be fed through 3 Phase electrical Supply at 415V AC ± 6 % The supply Frequency will be 50Hz ± 3%. d.</li>

                          <li>From point of power supply Only 3 Wires for Sigle Phase and 5 Wires for Three Phase are permissible from outgoing for internal distribution.</li>

                          <li>It is compulsory to internal distribution board inside the stall from exhibitor.</li>

                          <li>The exhibitor requiring supply at voltage level other than above shall make necessary arrangement for the level matching equipment such as transformer, voltage stabilizer, inverter etc. to match the supply voltage level to their load.</li>

                          <li>The frame of stationary motor and the metallic parts, not intended as conductors, including transformers and any other apparatus used for regulating or controlling electricity of voltage exceeding 250V but not exceeding 650V shall be earthed firmly by the conductor size as mentioned.</li>

                          <li>Exhibitor are advised to make arrangement for power conditioning equipment such as UPS, CVT etc. for their critical &amp; supply sensitive load/ equipment operating under very narrow band of tolerance.</li>

                          <li>The contractors shall use BIS marked PVC insulated 650/1100 V copper conductor wire for supplying electrical power to lighting &amp; motive load to be installed in stall.</li>

                          <li>All switch boards shall conform to BIS &amp; to Indian Electricity Act (amended).</li>

                          <li>The insulation tape used shall carry IS marking.</li>

                          <li>For lighting circuit, the minimum wire size shall be 1.5/2.5 sq.mm PVC insulated 650V grade FRLS copper wire. For 16A power point, the minimum wire size shall be 4sq.mm PVC insulated 650V grade FRLS copper wire. The IR value of cable used shall not be less than 1MΩ when measured with 500V DC megger.</li>

                          <li>Exhibitor can bring international adopter for their internal electrical connection.</li>

                          <li>The contractor shall use following size of protective conductors for equipment at their stall from point of supply (MCB Box).</li>

                          <div class="table-responsive">
                            <table class="table border text-nowrap text-md-nowrap table-bordered mb-2 mt-2 w-50">
                              <thead>
                                <tr>
                                  <th>Size of phase conductor</th>
                                  <th>
                                    Size of protective conductor of the same
                                    material as phase conductor
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Up to 4mm²</td>
                                  <td>Same size as that of phase conductor</td>
                                </tr>
                                <tr>
                                  <td>Above 4mm² & up to 16mm²</td>
                                  <td>Same size as that of phase conductor</td>
                                </tr>
                                <tr>
                                  <td>Above 16mm² & up to 35mm²</td>
                                  <td>16mm²</td>
                                </tr>
                                <tr>
                                  <td>Above 35mm²</td>
                                  <td>Half size of phase conductor</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <li>The earth wires shall be connected to the main earth firmly. After switching the entire load at stall, the voltage between neutral &amp; earth shall not exceed 10V.</li>

                          <li>Exhibitor shall ensure that, the contractor shall carry out all electrical works in the stall area as per Indian Electricity Rules 2005/ CEA Regulation 2010/ General Specifications for Electrical Works, Part I &amp; II by CPWD.</li>

                          <li>The Contractor shall carry out wiring at their installation as per IS-732:2010 with all safety precautions.</li>

                          <li>The load connected to power point shall be suitable for the socket and under no circumstances exceed the rated current capacity of the socket.</li>

                          <li>Exhibitors must install separate and independent MCBs/MCCBs/RCCBs of appropriated rating for their individual machines so as to automatically disconnect the supply in case of a) Overload b) Earth leakage or earth fault c) short circuit.</li>

                          <li>It is mandatory to use only reputed make wires like Polycom, KEI, Anchor etc and MCB/RCCB like Legrand, Siemens, ABB, Schneider for the electrical installation.</li>

                          <li>Wherever 3 ph connection is requested, the load shall be evenly distributed on all three phases. The current through neutral conductor or in other words, the current unbalance shall not exceed 5%.</li>

                          <li>The contractor shall also ensure that conductor size of the cable/ wire is suitable to cater connected load without overloading/overheating in normal operation and during abnormal conditions. This may be checked and verified by electrical consultant.</li>

                          <li>In case any material used by the contractor is found to be of inferior or sub-standard quality, the contractor shall be responsible for replacing the same without any loss of time as per the quality mutually agreed and mentioned above.</li>

                          <li>It is recommended to make use of low loss/ low heating choke manufactured as per IS and of reputed make namely Philips, Crompton, Bajaj, Wipro or equivalent.</li>

                          <li>The contractor shall control maximum 10 points or 800 watts whichever less, from single point.</li>

                          <li>Joint to the wires in any place is unacceptable. However, good quality connector of adequate rating properly covered cab be used.</li>

                          <li>Use 3-pin top / industrial to shall be made to take supply from sockets. The third pin shall be connected to earth through protective (loop earthing) conductor. It is strictly prohibited to insert wires directly into socket for drawing supply.</li>

                          <li>Adequate access to main power supply (relieving point) at stall shall be provided for cleaning &amp; maintenance purpose. A clear space of not less than 1 meter shall be provided in front of the switchboard. Materials particularly combustible shall not be dumped at this location.</li>

                          <li>All main electrical supply points must be kept easily accessible for operation and repairs and for isolation of power in the event of emergency. These should not be concealed or covered under any circumstances.</li>

                          <li>Exhibitors requesting for 3-phase supply shall draw single phase power for lighting purpose from 3-phase supply outlet using double pole MCBs. The double pole MCB/RCCB shall be arranged by the exhibitor.</li>

                          <li>The electrical supply will be released only after completion of wiring work conforming to the Indian standards &amp; codes of wiring and to the satisfaction of Electrical consultant.</li>

                          <li>UPS/Stabiliser with rating greater than 3kVA should have 3 Phase Input.</li>

                          <li>1 point of power supply will be provided to below 15 kw.</li>

                          <li>Exhibitors may contact the Electrical Consultant at venue office for any technical queries.</li>

                          <li>Exhibitors under Shell Scheme package would be provided with a plug point socket and a switch for a 230 V, 6 Amp A.C. supply. Consumption of power through this plug point for the connected load upto 1 kw is included in the cost of shell scheme package. However, additional power would be made available to them on extra payment.</li>

                          <li>Exhibitors shall bring their own electrical cables, wires, sockets, international electrical adaptor to connect their electrical installation.</li>

                          <li>The Exhibition authority arrange for supply of power will be entrusted with the authority for regulating and controlling the power supply to the exhibition halls and individual stalls.</li>

                        </ol>

                        <h6>ELECTRICAL INSTALLATION REGULATIONS</h6>

                        <ol>
                          <li>Electrical wiring and installation must be done by Exhibitors through registered professional technicians using proper wiring, switches etc. so as to ensure safety. The Organisers shall not be responsible or liable in case of any mishap due to use of sub-standard material or unskilled labour.</li>

                          <li>Lamps and appliances with high temperature surfaces should be guarded and used well away from combustible materials.</li>

                          <li>No light fitting or other appliance may be suspended from the roof of the exhibition hall.</li>

                          <li>Exhibitors are requested to review their internal wiring and connections thoroughly before going live. Also, Members should estimate the power requirement in advance so that, appropriate load management can be done. Switching from temporary to permanent power supply should be done in advance clear two days, so that testing and balancing can be done properly.</li>

                          <li>Exhibitor shall submit Electrical Work Completion Report to Hall Directors for permanent power connection as per the format. Power will be released on receipt of the completion report.</li>

                          <li>The Organisers reserve the right to disconnect any installation, which in their opinion is dangerous or likely to cause annoyance to visitors or other Exhibitors</li>

                          <li>In order to take care of voltage fluctuations, the Exhibitors are advised to fix up constant voltage transformers or insulation Transformer or stabilizers for CNC and other sensitive machines. Exhibitors are encouraged to use MCCB wherever necessary. The main supply points and electrical installations in the stand should be kept open for easy access and should not be concealed.</li>

                          <li>Electrical power should be drawn from designated points allocated to the exhibitor only. Any exhibitor or its designated contractor found drawing power from unauthorized sources will be liable to forfeiter of security deposit.</li>
                        </ol>

                      </div>
                    </div>
                  )}
                  <p style={{ margin: "0 0 0 10px" }}>
                    <span className="fw-semibold">Exhibitor Details:</span>
                  </p>
                  <div className="row m-0">
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label>Exhibitor Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={ExhibitorName}
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label htmlFor="validationCustom03">Stall No</label>
                      <input
                        type="text"
                        className="form-control"
                        value={StallName}
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label htmlFor="validationCustom03">Hall Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={HallName}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="row m-0">
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label>Open Sides</label>
                      <input
                        type="text"
                        className="form-control"
                        value={OpenSides}
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label htmlFor="validationCustom03">Area</label>
                      <input
                        type="text"
                        className="form-control"
                        value={StallArea}
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label htmlFor="validationCustom03">Stall Type</label>
                      <input
                        type="text"
                        className="form-control"
                        value={StallTypeName}
                        disabled={true}
                      />
                    </div>
                  </div>

                  <p style={{ margin: "0 0 0 10px" }}>
                    <span className="fw-semibold">Contractor Details:</span>
                  </p>
                  <div className="row m-0">
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label>Company Name</label>
                      <input
                        className="form-control"
                        value={CompanyName}
                        disabled={true}
                        onChange={(e) =>
                          !isDeadlinePassed &&
                          this.setState({
                            CompanyName: e.target.value,
                            CompanyNameErr: "",
                          })
                        }
                        maxLength={100}
                        type="text"
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {CompanyNameErr}
                        </span>
                      }
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label >Person Name</label>
                      <input
                        className="form-control"
                        value={PersonName}
                        disabled={true}
                        onChange={(e) =>
                          !isDeadlinePassed &&
                          this.setState({
                            PersonName: e.target.value,
                            PersonNameErr: "",
                          })
                        }
                        maxLength={70}
                        type="text"
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {PersonNameErr}
                        </span>
                      }
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label>Email</label>
                      <input
                        className="form-control"
                        value={Email}
                        disabled={true}
                        onChange={(e) =>
                          !isDeadlinePassed &&
                          this.setState({ Email: e.target.value, EmailErr: "" })
                        }
                        maxLength={100}
                        type="text"
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {EmailErr}
                        </span>
                      }
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label >Mobile No</label>
                      <input
                        className="form-control"
                        value={Mobile}
                        disabled={true}
                        onChange={(e) =>
                          !isDeadlinePassed &&
                          this.setState({
                            Mobile: e.target.value.replace(/\D/, ""),
                            MobileErr: "",
                          })
                        }
                        maxLength={sessionStorage.getItem("CurrencyID") == 1 ? 10 : 20}
                        type="text"
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {MobileErr}
                        </span>
                      }
                    </div>
                  </div>

                  <p style={{ margin: "0 0 0 10px" }}>
                    <span className="fw-semibold">No. of Passes/Bands:</span>
                  </p>
                  <div className="row m-0">
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label >Required for setup days<span className="required">*</span></label>
                      <input
                        className="form-control"
                        value={SetUpDayPasses}
                        disabled={is_View || isDeadlinePassed || StatusID == 2}
                        onChange={(e) =>
                          !isDeadlinePassed &&
                          this.setState({
                            SetUpDayPasses: e.target.value.replace(/\D/, ""),
                            SetUpDayPassesErr: "",
                          })
                        }
                        maxLength={20}
                        type="text"
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {SetUpDayPassesErr}
                        </span>
                      }
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label >Required for dismantle days<span className="required">*</span></label>
                      <input
                        className="form-control"
                        value={DismantleDayPasses}
                        disabled={is_View || isDeadlinePassed || StatusID == 2}
                        onChange={(e) =>
                          !isDeadlinePassed &&
                          this.setState({
                            DismantleDayPasses: e.target.value.replace(/\D/, ""),
                            DismantleDayPassesErr: "",
                          })
                        }
                        maxLength={20}
                        type="text"
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {DismantleDayPassesErr}
                        </span>
                      }
                    </div>
                  </div>

                  <div className="row m-3">
                    <div className="col-xl-3 col-lg-3 col-md-6 col-12 mb-4 px-2">
                      <div className="h-100" style={{ border: "1px solid #c9c4c4", borderRadius: "5px", overflow: "hidden" }}>
                        <p
                          style={{
                            padding: "15px",
                            background: "#e3e2e2",
                            textAlign: "center",
                          }}
                        >
                          {" "}
                          <span className="fw-semibold">
                            Floor Plan<span className="required">*</span>
                          </span>{" "}
                        </p>
                        <img
                          title=""
                          // src={`${url}${data.CateringImage}#toolbar=0&navpanes=0`}
                          src={`${displayfile_1}#toolbar=0&navpanes=0`}
                          // src='https://ems_uat.india-itme.com/document/Circular/10/Circular_10.pdf#toolbar=0&navpanes=0'
                          style={{ padding: '0px 20px', height: "270px", cursor: "pointer" }}
                          id="myIframe"
                          onClick={(e) => fileName_1 != '' && this.showImage("file_1", "Floor Plan")}
                        />
                        {/* <div
                        className="viewImageIframe"
                        onClick={(e) => this.showImage("file_1", "Floor Plan")}
                      /> */}
                        <div className="mb-2">
                          {fileName_1 != "" ? (
                            <>
                              <div className="d-flex" style={{ justifyContent: "center" }}>
                                <div className="chooseStallFile">
                                  <p className="overflow-membership m-0">{fileName_1}</p>
                                  {!isDeadlinePassed && !is_View && (
                                    <span
                                      className="membership_file_cross text-danger"
                                      onClick={(e) =>
                                        this.removeFile(e, "file_1")
                                      }
                                    >
                                      X
                                    </span>
                                  )}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="d-flex" style={{ justifyContent: "center" }}>
                              <input
                                type="file"
                                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                className="form-control mt-2"
                                style={{ width: "80%" }}
                                onChange={(e) => this.onFilePick(e, e.target.files, "file_1")}
                              />
                            </div>
                          )}
                          <p
                            className="text-aqua"
                            style={{ margin: "6px", textAlign: "center" }}
                          >
                            (Only .jpg, .jpeg, .png formats are allowed with maximum size of 3MB)
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-12 mb-4 px-2">
                      <div className="h-100" style={{ border: "1px solid #c9c4c4", borderRadius: "5px", overflow: "hidden" }}>
                        <p
                          style={{
                            padding: "15px",
                            background: "#e3e2e2",
                            textAlign: "center",
                          }}
                        >
                          {" "}
                          <span className="fw-semibold">
                            Front Elevation<span className="required">*</span>
                          </span>
                        </p>
                        <img
                          title=""
                          src={`${displayfile_3}#toolbar=0&navpanes=0`}
                          style={{ padding: '0px 20px', height: "270px", cursor: "pointer" }}
                          id="myIframe"
                          onClick={(e) => fileName_3 != '' && this.showImage("file_3", "Front Elevation")}
                        />
                        <div className="mb-2">
                          {fileName_3 != "" ? (
                            <>
                              <div className="d-flex" style={{ justifyContent: "center" }}>
                                <div className="chooseStallFile">
                                  <p className="overflow-membership m-0">{fileName_3}</p>
                                  {!isDeadlinePassed && !is_View && (
                                    <span
                                      className="membership_file_cross text-danger"
                                      onClick={(e) =>
                                        this.removeFile(e, "file_3")
                                      }
                                    >
                                      X
                                    </span>
                                  )}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="d-flex" style={{ justifyContent: "center" }}>
                              <input
                                type="file"
                                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                className="form-control mt-2"
                                style={{ width: "80%" }}
                                onChange={(e) => this.onFilePick(e, e.target.files, "file_3")}
                              />
                            </div>
                          )}
                          <p
                            className="text-aqua"
                            style={{ margin: "6px", textAlign: "center" }}
                          >
                            (Only .jpg, .jpeg, .png formats are allowed with maximum size of 3MB)
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-3 col-lg-3 col-md-6 col-12 mb-4 px-2">
                      <div className="h-100" style={{ border: "1px solid #c9c4c4", borderRadius: "5px", overflow: "hidden" }}>
                        <p
                          style={{
                            padding: "15px",
                            background: "#e3e2e2",
                            textAlign: "center",
                          }}
                        >
                          {" "}
                          <span className="fw-semibold">
                            Side Elevation<span className="required">*</span>
                          </span>
                        </p>
                        <img
                          title=""
                          src={`${displayfile_4}#toolbar=0&navpanes=0`}
                          style={{ padding: '0px 20px', height: "270px", cursor: "pointer" }}
                          id="myIframe"
                          onClick={(e) => fileName_4 != '' && this.showImage("file_4", "Side Elevation")}
                        />
                        <div className="mb-2">
                          {fileName_4 != "" ? (
                            <>
                              <div className="d-flex" style={{ justifyContent: "center" }}>
                                <div className="chooseStallFile">
                                  <p className="overflow-membership m-0">{fileName_4}</p>
                                  {!isDeadlinePassed && !is_View && (
                                    <span
                                      className="membership_file_cross text-danger"
                                      onClick={(e) =>
                                        this.removeFile(e, "file_4")
                                      }
                                    >
                                      X
                                    </span>
                                  )}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="d-flex" style={{ justifyContent: "center" }}>
                              <input
                                type="file"
                                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                className="form-control mt-2"
                                style={{ width: "80%" }}
                                onChange={(e) => this.onFilePick(e, e.target.files, "file_4")}
                              />
                            </div>
                          )}
                          <p
                            className="text-aqua"
                            style={{ margin: "6px", textAlign: "center" }}
                          >
                            (Only .jpg, .jpeg, .png formats are allowed with maximum size of 3MB)
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-12 mb-4 px-2">
                      <div className="h-100" style={{ border: "1px solid #c9c4c4", borderRadius: "5px", overflow: "hidden" }}>
                        <p
                          style={{
                            padding: "15px",
                            background: "#e3e2e2",
                            textAlign: "center",
                          }}
                        >
                          {" "}
                          <span className="fw-semibold">
                            3D View<span className="required">*</span>
                          </span>
                        </p>
                        <img
                          title=""
                          src={`${displayfile_2}#toolbar=0&navpanes=0`}
                          style={{ padding: '0px 20px', height: "270px", cursor: "pointer" }}
                          id="myIframe"
                          onClick={(e) => fileName_2 != '' && this.showImage("file_2", "3D View")}
                        />
                        <div className="mb-2">
                          {fileName_2 != "" ? (
                            <>
                              <div className="d-flex" style={{ justifyContent: "center" }}>
                                <div className="chooseStallFile">
                                  <p className="overflow-membership m-0">{fileName_2}</p>
                                  {!isDeadlinePassed && !is_View && (
                                    <span
                                      className="membership_file_cross text-danger"
                                      onClick={(e) =>
                                        this.removeFile(e, "file_2")
                                      }
                                    >
                                      X
                                    </span>
                                  )}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="d-flex" style={{ justifyContent: "center" }}>
                              <input
                                type="file"
                                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                className="form-control mt-2"
                                style={{ width: "80%" }}
                                onChange={(e) => this.onFilePick(e, e.target.files, "file_2")}
                              />
                            </div>
                          )}
                          <p
                            className="text-aqua"
                            style={{ margin: "6px", textAlign: "center" }}
                          >
                            (Only .jpg, .jpeg, .png formats are allowed with maximum size of 3MB)
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row m-3">
                    <div className="col-xl-3 col-lg-3 col-md-6 col-12 mb-4 px-2">
                      <div className="h-100" style={{ border: "1px solid #c9c4c4", borderRadius: "5px", overflow: "hidden" }}>
                        <p
                          style={{
                            padding: "15px",
                            background: "#e3e2e2",
                            textAlign: "center",
                          }}
                        >
                          {" "}
                          <span className="fw-semibold">
                            Technical layout placement of utilities (Power, Water, and Air)<span className="required">*</span>
                          </span>
                        </p>
                        <img
                          title=""
                          src={`${displayfile_7}#toolbar=0&navpanes=0`}
                          style={{ padding: '0px 20px', height: "270px", cursor: "pointer" }}
                          id="myIframe"
                          onClick={(e) => fileName_7 != '' && this.showImage("file_7", "TechnicalLayout")}
                        />
                        <div className="mb-2">
                          {fileName_7 != "" ? (
                            <>
                              <div className="d-flex" style={{ justifyContent: "center" }}>
                                <div className="chooseStallFile">
                                  <p className="overflow-membership m-0">{fileName_7}</p>
                                  {!isDeadlinePassed && !is_View && (
                                    <span
                                      className="membership_file_cross text-danger"
                                      onClick={(e) =>
                                        this.removeFile(e, "file_7")
                                      }
                                    >
                                      X
                                    </span>
                                  )}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="d-flex" style={{ justifyContent: "center" }}>
                              <input
                                type="file"
                                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                className="form-control mt-2"
                                style={{ width: "80%" }}
                                onChange={(e) => this.onFilePick(e, e.target.files, "file_7")}
                              />
                            </div>
                          )}
                          <p
                            className="text-aqua"
                            style={{ margin: "6px", textAlign: "center" }}
                          >
                            (Only .jpg, .jpeg, .png formats are allowed with maximum size of 3MB)
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-12 mb-4 px-2">
                      <div className="h-100" style={{ border: "1px solid #c9c4c4", borderRadius: "5px", overflow: "hidden" }}>
                        <p
                          style={{
                            padding: "15px",
                            background: "#e3e2e2",
                            textAlign: "center",
                          }}
                        >
                          {" "}
                          <span className="fw-semibold">
                            Structural certificates from certified Engineer (Applicable for double
                            story stall){" "}
                          </span>
                        </p>
                        {/* <img
                        title=""
                        src={`${fileName_5 != '' ? displayfile_5 : ''}#toolbar=0&navpanes=0`}
                        style={{ padding:'0px 20px', height: "270px", cursor: "pointer" }}
                        onClick={(e) => fileName_5 != '' &&
                          this.showImage(
                            "file_5",
                            "Structural certificates from certified Engineer"
                          )
                        }
                      /> */}
                        <img
                          title=""
                          src={`${fileName_5 != '' ? displayfile_5 : ''}#toolbar=0&navpanes=0`}
                          style={{ padding: '0px 20px', height: "270px", cursor: "pointer" }}
                          id="myIframe"
                          onClick={(e) => fileName_5 != '' &&
                            this.showImage(
                              "file_5",
                              "Structural certificates from certified Engineer"
                            )
                          }
                        />
                        <div className="mb-2">
                          {fileName_5 != "" ? (
                            <>
                              <div className="d-flex" style={{ justifyContent: "center" }}>
                                <div className="chooseStallFile">
                                  <p className="overflow-membership m-0">{fileName_5}</p>
                                  {!isDeadlinePassed &&
                                    !is_View && (
                                      <span
                                        className="membership_file_cross text-danger"
                                        onClick={(e) =>
                                          this.removeFile(e, "file_5")
                                        }
                                      >
                                        X
                                      </span>
                                    )}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="d-flex" style={{ justifyContent: "center" }}>
                              <input
                                type="file"
                                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                className="form-control mt-2"
                                style={{ width: "80%" }}
                                onChange={(e) => this.onFilePick(e, e.target.files, "file_5")}
                                disabled={is_View || isDeadlinePassed}
                              />
                            </div>
                          )}
                          <p
                            className="text-aqua"
                            style={{ margin: "6px", textAlign: "center" }}
                          >
                            (Only .jpg, .jpeg, .png formats are allowed with maximum size of 3MB)
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-12 mb-4 px-2">
                      <div className="h-100" style={{ border: "1px solid #c9c4c4", borderRadius: "5px", overflow: "hidden" }}>
                        <p
                          style={{
                            padding: "15px",
                            background: "#e3e2e2",
                            textAlign: "center",
                          }}
                        >
                          <span className="fw-semibold">
                            {" "}
                            Fire safety certificates from certified Engineer (Applicable for
                            double story stall){" "}
                          </span>
                        </p>
                        <img
                          title=""
                          src={`${fileName_6 != '' ? displayfile_6 : ''}#toolbar=0&navpanes=0`}
                          style={{ padding: '0px 20px', height: "270px", cursor: "pointer" }}
                          id="myIframe"
                          onClick={(e) => fileName_6 != '' &&
                            this.showImage(
                              "file_6",
                              "Fire safety certificates from certified Engineer"
                            )
                          }
                        />
                        <div className="mb-2">
                          {fileName_6 != "" ? (
                            <>
                              <div className="d-flex" style={{ justifyContent: "center" }}>
                                <div className="chooseStallFile">
                                  <p className="overflow-membership m-0">{fileName_6}</p>
                                  {!isDeadlinePassed && (
                                    <span
                                      className="membership_file_cross text-danger"
                                      onClick={(e) =>
                                        !is_View ? this.removeFile(e, "file_6") : ""
                                      }
                                    >
                                      X
                                    </span>
                                  )}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="d-flex" style={{ justifyContent: "center" }}>
                              <input
                                type="file"
                                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                className="form-control mt-2"
                                style={{ width: "80%" }}
                                disabled={is_View || isDeadlinePassed}
                                onChange={(e) => this.onFilePick(e, e.target.files, "file_6")}
                              />
                              {/* <span className="text-danger" style={{ fontSize: '12px', textAlign: 'center', display: 'block' }}>
                                                        Max 3MB | Image formats only
                                                    </span> */}
                            </div>
                          )}
                          <p
                            className="text-aqua"
                            style={{ margin: "6px", textAlign: "center" }}
                          >
                            (Only .jpg, .jpeg, .png formats are allowed with maximum size of 3MB)
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row m-1">
                    <form>
                      <span className="fw-semibold">
                        {" "}
                        <label>Remark</label>
                      </span>
                      <textarea
                        class="form-control"
                        value={Remark}
                        onChange={(e) => this.setState({ Remark: e.target.value })}
                        maxLength={300}
                        disabled={is_View || isDeadlinePassed}
                        rows="3"
                      ></textarea>


                      {!isHideSection && (
                        <label class="d-flex mt-4">
                          <input
                            type="checkbox"
                            checked={Is_Agree}
                            disabled={is_View || isDeadlinePassed || StatusID == 2}
                            onChange={(e) =>
                              !isDeadlinePassed &&
                              this.setState({ Is_Agree: e.target.checked, Is_AgreeErr: "" })
                            }
                          />
                          <span className="fw-semibold">
                            I confirm the above requirements and disclaimer
                            <span className="required">*</span>.
                          </span>
                        </label>
                      )}
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {Is_AgreeErr}
                        </span>
                      }
                    </form>
                  </div>

                  <div class="d-flex m-3">
                    {!is_View ? (
                      <button type="button"
                        className="btn btn-aqua rounded-1 d-block mt-3 mb-3 mx-2"
                        onClick={() => this.setState({ isOpenConfirmationModal: true })}
                      >{this.state.StatusID == 0 ? "Submit" : "Update"}</button>
                    ) : (
                      <></>
                    )}
                    {!isHideSection && <button
                      className="btn rounded-0 d-block mt-3 mb-3 btn-gray"
                      onClick={() => this.handleCancel()}
                    >
                      Back
                    </button>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <Modal
          isOpen={isOpenConfirmationModal}
          onRequestClose={() => this.setState({ isOpenConfirmationModal: false })}
          shouldCloseOnEsc={true}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={false}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header text-white p-2">
                <h6 className="modal-title fw-normal">Do you want to {this.state.StatusID == 0 ? "Submit" : "Update"} ?</h6>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => this.setState({ isOpenConfirmationModal: false })}
                />
              </div>

              <div className="modal-body">
                <p>I acknowledge that the submitted booth design complies with the Organizer's Booth Design Guidelines and venue regulations.</p>
              </div>


              <div className="modal-footer">
                <button type="button" className="btn btn-aqua"
                  onClick={() => this.handleSubmit()}
                >{this.state.StatusID == 0 ? "Submit" : "Update"}</button>
                <button
                  className="btn btn-gray"
                  onClick={() => this.setState({ isOpenConfirmationModal: false })}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={isOpen}
          onRequestClose={() => this.setState({ isOpen: false })}
          shouldCloseOnEsc={true}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={false}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header text-white p-2">
                <h6 className="modal-title fw-normal">{modalImageName}</h6>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => this.setState({ isOpen: false })}
                />
              </div>

              <div className="modal-body">
                <img
                  title=""
                  // src={`${url}${data.CateringImage}#toolbar=0&navpanes=0`}
                  src={`${modalImagePath}#toolbar=0&navpanes=0`}
                // src='https://ems_uat.india-itme.com/document/Circular/10/Circular_10.pdf#toolbar=0&navpanes=0'
                // style={{ width: "905px", height: "550px" }}
                // id="myIframe"
                />
              </div>


              <div className="modal-footer">
                <button
                  className="btn btn-gray"
                  onClick={() => this.setState({ isOpen: false })}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>

        {/* <Modal isOpen={isOpen} onHide={() => this.setState({ isOpen: false })} size="xl" style={{ zIndex: '99999' }}>
          <Modal.Header>
            <Modal.Title> {modalImageName}</Modal.Title>
            <span
              onClick={() => this.setState({ isOpen: false })}
              style={{ cursor: "pointer", fontWeight: "800" }}
            >
              X
            </span>
          </Modal.Header>

          <Modal.Body style={{ marginBottom: "0px", textAlign: "center" }}>
            <img
              title=""
              // src={`${url}${data.CateringImage}#toolbar=0&navpanes=0`}
              src={`${modalImagePath}#toolbar=0&navpanes=0`}
            // src='https://ems_uat.india-itme.com/document/Circular/10/Circular_10.pdf#toolbar=0&navpanes=0'
            // style={{ width: "905px", height: "550px" }}
            // id="myIframe"
            />
          </Modal.Body>
        </Modal> */}

      </>
    );
  }
}
export default withRouter(connect(null, {
  getStallDesignDetails_action, insertUpdateStallDesign_action, insertUpdateExhibitorContractorBadgeApplication_action,
  getExhibitorContractorBadgeApplicationDetails_action,
})(StallDesign))